/**
 * How a report row reached v2 (SPEC-AUDITOR-CSV-IMPORT.md section 7). A quiet
 * label, never a warning: outlined chip in the same neutral tone for all three
 * sources, no colour coding -- an imported row is as legitimate as a synced one.
 *
 * The border is pinned to textSecondary because MUI's default outlined-chip
 * border (grey[400]/grey[700]) computes 1.88:1 light / 2.61:1 dark against
 * paper, under the 3:1 non-text minimum; textSecondary is 5.88:1 / 7.71:1.
 */
import Chip from '@mui/material/Chip';

import type { ReportSource } from '../../api/index.ts';
import { palette } from '../../theme.ts';

const LABELS: Record<string, string> = {
  sync: 'Sync',
  manual: 'Manual',
  import: 'Import',
};

export interface SourceBadgeProps {
  source: ReportSource | undefined;
}

export function SourceBadge({ source }: Readonly<SourceBadgeProps>): React.JSX.Element | null {
  if (source === undefined) return null;
  // A value outside the union (hand-backfilled row) shows itself rather than vanishing.
  return (
    <Chip
      size="small"
      variant="outlined"
      label={LABELS[source] ?? source}
      sx={{ height: 20, borderColor: palette.textSecondary }}
    />
  );
}

export default SourceBadge;
